class countrySelector {
    constructor(elem) {
        this.elem = elem;
        this.countrySelectorToggle = document.getElementById('country-selector-toggle');
    }

    init() {
        this.behaviourOnChange();
    }

    behaviourOnChange() {
        const countrySelectorToggleHandling = () => {
            if (this.countrySelectorToggle.checked) {
                countrySelector.preventScrolling();
                document.addEventListener('click', this.bodyClickListener);
                return;
            }

            countrySelector.allowScrolling();
            document.removeEventListener('click', this.bodyClickListener);
        };

        this.countrySelectorToggle.addEventListener('change', countrySelectorToggleHandling, false);
    }

    bodyClickListener(e) {
        const { target } = e;
        const isNavigation = target.closest('.country-selector__container') !== null
            || document.querySelector('.country-selector__container') === target
            || target.closest('.country-selector-toggle__label--close') !== null;

        if (!isNavigation) {
            countrySelector.closeNavigation();
            countrySelector.allowScrolling();
        }
    }

    static closeNavigation() {
        const countrySelectorToggle = document.getElementById('country-selector-toggle');
        countrySelector.checkboxHelper(countrySelectorToggle, false, true);
    }

    static preventScrolling(element = 'body') {
        window.requestAnimationFrame(() => {
            document.querySelector(element).classList.add('no-scroll');
        });
    }

    static allowScrolling(element = 'body') {
        window.requestAnimationFrame(() => {
            document.querySelector(element).classList.remove('no-scroll');
        });
    }

    static checkboxHelper(checkbox, check, triggerChange) {
        if (typeof checkbox.prop === 'undefined') {
            checkbox.checked = check;

            if (triggerChange) {
                const event = new Event('change');
                checkbox.dispatchEvent(event);
            }
            return;
        }
        checkbox
            .prop('checked', check)
            .attr('checked', check);
        if (triggerChange) {
            checkbox.trigger('change');
        }
    }
}

export default countrySelector;
